import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, MessageCircle, BookOpen } from 'lucide-react';
import { motion } from 'framer-motion';
import AuthModal from '../components/AuthModal';

const WelcomeBackPage = () => {
  const navigate = useNavigate();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authMode, setAuthMode] = useState<'sign-in' | 'sign-up'>('sign-in');

  const handleAuthSuccess = () => {
    setShowAuthModal(false);
    navigate('/dashboard');
  };

  const handleCreateAccount = () => {
    setAuthMode('sign-up');
    setShowAuthModal(true);
  };

  const handleSignIn = () => {
    setAuthMode('sign-in');
    setShowAuthModal(true);
  };

  const handleCloseModal = () => {
    setShowAuthModal(false);
    setAuthMode('sign-in');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50/50 to-pink-50/50 py-8 px-4">
      <div className="max-w-lg mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white rounded-2xl shadow-lg p-8"
        >
          <div className="flex items-center justify-center mb-8">
            <div className="h-16 w-16 bg-gradient-to-r from-purple-100 to-pink-100 rounded-2xl flex items-center justify-center">
              <User className="h-8 w-8 text-purple-600" />
            </div>
          </div>

          <h1 className="text-2xl font-semibold text-center text-gray-900 mb-4">
            Join Space to Think
          </h1>
          
          <p className="text-gray-600 text-center mb-8">
            Create an account or sign in to access your personal space and continue your journey.
          </p>

          <div className="space-y-6">
            <div className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-xl p-6 space-y-4">
              <h2 className="font-medium text-gray-900">Your Personal Space Includes:</h2>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <MessageCircle className="h-5 w-5 text-purple-600 mr-3 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700">Private conversations with Echo</span>
                </li>
                <li className="flex items-start">
                  <BookOpen className="h-5 w-5 text-purple-600 mr-3 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700">Personal reflections and insights</span>
                </li>
                <li className="flex items-start">
                  <User className="h-5 w-5 text-purple-600 mr-3 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700">Your own profile and preferences</span>
                </li>
              </ul>
            </div>

            <div className="flex flex-col space-y-3">
              <button
                onClick={handleSignIn}
                className="w-full py-3 bg-gradient-to-r from-[#a85ff7] to-[#e457b5] text-white rounded-lg hover:opacity-90 transition-opacity font-medium"
              >
                Sign In
              </button>
              <button
                onClick={handleCreateAccount}
                className="w-full py-3 border-2 border-purple-200 text-purple-600 rounded-lg hover:bg-purple-50 transition-colors font-medium"
              >
                Create Account
              </button>
            </div>
          </div>
        </motion.div>
      </div>

      <AuthModal
        isOpen={showAuthModal}
        onClose={handleCloseModal}
        onSuccess={handleAuthSuccess}
        mode={authMode}
      />
    </div>
  );
};

export default WelcomeBackPage;